const postAreasStr = {
  toastrSuccess: 'Departamento agregado',
  toastrSuccess1: ' fue agregado con éxito',
  toastrError: 'Departamento ya registrado', 
  toastrError2: 'Introduzca otro nombre'
};

export default postAreasStr;
